<template>
  <v-container fluid>
    <v-row dense class="mt-6">
      <v-col lg="12" md="12" sm="12">
        <p class="font-bold text-base" style="margin: 0; padding: 0">
          Push Notifications
        </p>
      </v-col>
      <v-col
        lg="3"
        md="3"
        sm="6"
        style="font-weight: 500; font-size: 16px; color: #112a46"
      >
        <router-link :to="`/marketing/announcement-details`">
          <v-card
            class="mx-auto shadow-0"
            rounded
            style="border: 1px solid #dcdcdc"
          >
            <v-card-text class="font-weight-bold">
              <v-row align="center" justify="center">
                <div class="col-12 d-flex justify-space-between align-center">
                  <div class="d-flex gap-x-4">
                    <v-btn fab elevation="0" x-small class="mt-2">
                      <NotificationIcon />
                    </v-btn>
                    <p class="font-bold text-base mt-4 blue-text">
                      Marketing Notifications
                    </p>
                  </div>
                  <div
                    class="text-center"
                    style="font-size: 24px; font-weight: 500"
                  ></div>
                </div>
              </v-row>
            </v-card-text>
          </v-card>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import NotificationIcon from "@/assets/images/marketing/notification.svg";

export default {
  name: "MarketingHomePage",
  components: {
    NotificationIcon,
  },
  data() {
    return {
      slug: "",
      title: "",
      type: "",
      data: {
        newsletter: {
          total: 0,
        },
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.justify_me_center {
  display: flex;
  justify-content: center; /* Center horizontally */
}

.template-btn {
  background-color: rgba(17, 42, 70, 0.2);
  color: rgba(17, 42, 70, 1);

  &:hover {
    background-color: #112a46;
    color: rgba(255, 255, 255, 1);
  }
}

.active-btn-class {
  background-color: #00b0af !important;
  color: #fff !important;
  &:hover {
    background-color: #112a46 !important;
    color: rgba(255, 255, 255, 1) !important;
  }
}
</style>
